<template>
  <div class="main">
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark navbar-hs321">
        <router-link to="/" class="navbar-brand">
            <img src="@/assets/img/logo_hs321.png" alt="hardsoft321" class="navbar-brand-img-hs321">
        </router-link>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="lab321-buttons-site">
          <ul class="navbar-nav" style="flex-direction: row;">
            <li class="nav-item mr-2">
              <a href="/static/files/profile_hardsoft321_main_projects.pdf" target="_blank" class="btn btn-purple" role="button" aria-pressed="true">Наш профиль</a>
            </li>
            <li class="nav-item mr-2">
              <a href="http://bush10.org/" target="_blank" class="btn btn-warning" role="button" aria-pressed="true">Для СхО</a>
            </li>
            <li class="nav-item">
              <a href="http://lab321.org/" target="_blank" class="btn btn-primary ml-auto" role="button" aria-pressed="true">NetApp</a>
            </li>
          </ul>
        </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Решения
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="dropdown-item" to="/products/teamasservice">Команда-как-Сервис</router-link>
                <router-link class="dropdown-item" to="/products/bizopsdev321">BizOpsDev321</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/products/app321">App321</router-link>
                <router-link class="dropdown-item" to="/products/suitecrm">SuiteCRM</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/products/waterman3">Биллинг ЖКХ</router-link>
                <a class="dropdown-item" href="https://hardsoft321.org/static/files/gis_exchange.html" target="_blank">Обмен с ГИС ЖКХ</a>
                <!-- <a class="dropdown-item" href="https://hardsoft321.org/waterman/" target="_blank">Waterman3</a> -->
                <div class="dropdown-divider"></div>
                <!-- <router-link class="dropdown-item" to="/products/mrpq321">MRP: q321</router-link> -->
                <router-link class="dropdown-item" to="/products/importsubst">Сложные ИТ-системы</router-link>
                <!-- <a class="dropdown-item" href="#">SugarCRM CE</a> -->
              </div>
            </li>
            <a href="https://hardsoft321.org/sugarcrm/demo/" target="_blank" class="btn btn-purple" role="button" aria-pressed="true">Демо321</a>

            <router-link class="nav-item" to="/price" tag="li">
              <a class="nav-link">Цены</a>
            </router-link>
            <!-- <router-link class="nav-item" to="/license" tag="li">
              <a class="nav-link">Лицензия</a>
            </router-link> 
            <router-link class="nav-item" to="/vacancies" tag="li">
              <a class="nav-link">Вакансии</a> -->
            </router-link>
            <router-link class="nav-item" to="/about" tag="li">
              <a class="nav-link">О компании</a>
            </router-link>
            <router-link class="nav-item" to="/contacts" tag="li">
              <a class="nav-link">Контакты</a>
            </router-link>
          </ul>
        </div>
      </nav>
    </div>
</template>

<script>
  export default {
    name: 'Menu',
    data () {
      return {
        msg: ''
      }
    },
    watch: {
        '$route' () {
           $('#navbarSupportedContent').collapse('hide');
        }
    }
  };
  $(function(){
    $(window).scroll(function() {
      if($(this).scrollTop() > 10) {
        $('.navbar-hs321').addClass('navbar-hs321-show');
        $('.navbar-brand-img-hs321').addClass('navbar-brand-img-hs321-small');
      }
      else{
        $('.navbar-hs321').removeClass('navbar-hs321-show');
        $('.navbar-brand-img-hs321').removeClass('navbar-brand-img-hs321-small');
      }
    });
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-hs321 {
    border-bottom: 1px solid rgba(255,255,255,0.1);
    background-color: rgba(255,255,255,0);
    transition: 0.3s;
  }
  .navbar-hs321-show {
    border-color: #ebebeb;
    background-color: #3f4652;
  }

  .navbar-hs321 .navbar-brand img {
    transition: 0.3s;
  }
  .navbar-brand-img-hs321 {
    width: 240px;
    height: 65px;
  }
  .navbar-brand-img-hs321-small {
    width: 148px;
    height: 40px;
  }

  .navbar-nav .nav-item .nav-link {
    color: #fff;
  }

  .navbar-nav .nav-item.active .nav-link,
  .navbar-nav .nav-item:hover .nav-link,
  .navbar-light .navbar-nav .nav-link:focus {
    /*color: #ffc107;*/
    color: #b385ff;
  }
  .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #000;
  }
  .dropdown-item.active, .dropdown-item:active {
    /*color: #ffc107;*/
    color: #b385ff;
    text-decoration: none;
    background-color: #3f4652;
  }
  @media (max-width: 991.98px) {
    .navbar-hs321 {
      border-color: #ebebeb;
      background-color: #3f4652;
    }
    .navbar-brand-img-hs321-small {
      width: 148px;
      height: 40px;
    }
    .navbar-brand-img-hs321 {
      width: 148px;
      height: 40px;
    }
    #lab321-buttons-site {
      display: flex!important;
      margin-top: 5px;
    }
  }
    li a {
        font-size: 15px;
    }
    @media (max-width: 365px) {
        .btn {
            padding: .3rem .43rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/parts/MainMenu.vue